import styled from '@emotion/styled';

export const CollectionRuleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
`;
